import type {DefaultError} from "@tanstack/react-query";
import {keepPreviousData} from "@tanstack/react-query";
import type {UrlQueryKey} from "~/query/queryClient.ts";
import {useCustomQuery} from "~/query/queryClient.ts";
import type {PageResponse} from "~/services/ApiTypes.ts";
import type {ContractLink, LinkStatus} from "./contractExplorerTypes.ts";
import {contractDetailUrl} from "./useContractDetailQuery.ts";

/** `GET /api/data/{databag_id}/contracts/{id}/links/` */
export const contractLinksUrl = (bagId: number, contractId: number) => `${contractDetailUrl(bagId, contractId)}links/`;

export type ContractLinksParams = {
    status: LinkStatus;
    page: number;
    pageSize: number;
    /** DRF ordering over `confidence`, `part__p_spend`, `part__p_ddate_1`, `part__p_id`, `line`. */
    ordering?: string;
};

/** One page of the bundle's links of one status, each with its transaction and competing bundles. */
export function useContractLinksQuery(bagId: number, contractId: number, p: ContractLinksParams) {
    const params: Record<string, string | number> = {
        status: p.status, offset: p.page * p.pageSize, limit: p.pageSize,
        ...(p.ordering ? {ordering: p.ordering} : {}),
    };
    return useCustomQuery<PageResponse<ContractLink>, DefaultError, PageResponse<ContractLink>, UrlQueryKey>({
        queryKey: [contractLinksUrl(bagId, contractId), {params}],
        enabled: bagId > 0 && contractId > 0,
        staleTime: 5 * 60_000,
        placeholderData: keepPreviousData,
    });
}
